function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const mapToCamelCaseMaster = ({
  pk,
  is_active,
  from_status,
  to_status,
  notify_to_email,
  sla_unit,
  created_at,
  notification_frequency,
  notification_limit,
  entity_name,
  notification_frequency_unit,
  notify_on_state_change,
  workflow,
  workflow_sequence,
  notify_to_actors,
  email_template_actors,
  sms_template_actors,
  console_template_actors,
  push_template_actors,
  email_template_roles,
  sms_template_roles,
  console_template_roles,
  push_template_roles,
  notify_on_entry,
  ...rest
}) => {
  return {
    pk,
    isActive: is_active,
    fromStatus: from_status,
    toStatus: to_status,
    notifyToEmail: notify_to_email,
    slaUnit: sla_unit,
    createdAt: created_at,
    notificationFrequency: notification_frequency,
    notificationLimit: notification_limit,
    entityName: entity_name,
    notificationFrequencyUnit: notification_frequency_unit,
    notifyOnStateChange: notify_on_state_change,
    workflow: workflow,
    workflowSequence: workflow_sequence,
    notifyToActors: notify_to_actors,
    emailTemplateActors: email_template_actors,
    smsTemplateActors: sms_template_actors,
    consoleTemplateActors: console_template_actors,
    pushTemplateActors: push_template_actors,
    emailTemplateRoles: email_template_roles,
    smsTemplateRoles: sms_template_roles,
    consoleTemplateRoles: console_template_roles,
    pushTemplateRoles: push_template_roles,
    notifyOnEntry: notify_on_entry,
    ...rest
  };
};
class TransitionMasterEntity {
  constructor({
    mapValues,
    ...data
  }) {
    _defineProperty(this, "mapToSnakeCase", () => {
      return {
        sla: this.sla,
        sla_unit: this.slaUnit,
        from_status: this.fromStatus.pk ? {
          pk: this.fromStatus.pk
        } : {},
        to_status: this.toStatus.pk ? {
          pk: this.toStatus.pk
        } : {},
        notify_to_email: this.notifyToEmail,
        is_active: this.isActive,
        organisation: this.organisation,
        notification_frequency: this.notificationFrequency,
        notification_limit: this.notificationLimit,
        entity_name: this.entityName,
        notification_frequency_unit: this.notificationFrequencyUnit,
        notify_on_state_change: this.notifyOnStateChange,
        workflow: this.workflow?.pk ? this.workflow : {},
        workflowSequence: this.workflowSequence,
        notify_to_actors: this.notifyToActors,
        email_template_actors: this.emailTemplateActors?.pk ? {
          pk: this.emailTemplateActors.pk
        } : {},
        sms_template_actors: this.smsTemplateActors?.pk ? {
          pk: this.smsTemplateActors.pk
        } : {},
        push_template_actors: this.pushTemplateActors?.pk ? {
          pk: this.pushTemplateActors.pk
        } : {},
        console_template_actors: this.consoleTemplateActors?.pk ? {
          pk: this.consoleTemplateActors.pk
        } : {},
        email_template_roles: this.emailTemplateRoles?.pk ? {
          pk: this.emailTemplateRoles.pk
        } : {},
        push_template_roles: this.pushTemplateRoles?.pk ? {
          pk: this.pushTemplateRoles.pk
        } : {},
        sms_template_roles: this.smsTemplateRoles?.pk ? {
          pk: this.smsTemplateRoles.pk
        } : {},
        console_template_roles: this.consoleTemplateRoles?.pk ? {
          pk: this.consoleTemplateRoles.pk
        } : {},
        notify_on_entry: this.notifyOnEntry
      };
    });
    if (mapValues) data = mapToCamelCaseMaster(data);
    this.fromStatus = data.fromStatus;
    this.toStatus = data.toStatus;
    this.sla = data.sla;
    this.slaUnit = data.slaUnit;
    this.notifyToEmail = data.notifyToEmail;
    this.organisation = data.organisation;
    this.pk = data.pk;
    this.createdAt = data.createdAt;
    this.isActive = data.isActive;
    this.notificationFrequency = data.notificationFrequency;
    this.notificationLimit = data.notificationLimit;
    this.entityName = data.entityName || '';
    this.notificationFrequencyUnit = data.notificationFrequencyUnit || '';
    this.notifyOnStateChange = data.notifyOnStateChange;
    this.workflow = data.workflow;
    this.workflowSequence = data.workflowSequence;
    this.notifyToActors = data.notifyToActors;
    this.emailTemplateActors = data.emailTemplateActors;
    this.smsTemplateActors = data.smsTemplateActors;
    this.consoleTemplateActors = data.consoleTemplateActors;
    this.pushTemplateActors = data.pushTemplateActors;
    this.emailTemplateRoles = data.emailTemplateRoles;
    this.smsTemplateRoles = data.smsTemplateRoles;
    this.consoleTemplateRoles = data.consoleTemplateRoles;
    this.pushTemplateRoles = data.pushTemplateRoles;
    this.notifyOnEntry = data.notifyOnEntry;
  }
}
const mapToCamelCase = ({
  pk,
  is_active,
  transition_master,
  allowed_by_pks,
  notify_pks,
  attribute_only_transition,
  entity_attribute,
  attribute_condition,
  notify_to_email,
  created_at,
  email_template_actors,
  sms_template_actors,
  console_template_actors,
  push_template_actors,
  email_template_roles,
  sms_template_roles,
  console_template_roles,
  push_template_roles,
  rule_groups_pks,
  ...rest
}) => {
  return {
    pk,
    isActive: is_active,
    transitionMaster: transition_master,
    allowedByPks: allowed_by_pks,
    notifyPks: notify_pks,
    attributeOnlyTransition: attribute_only_transition,
    entityAttribute: entity_attribute,
    attributeCondition: attribute_condition,
    notifyToEmail: notify_to_email,
    createdAt: created_at,
    emailTemplateActors: email_template_actors,
    smsTemplateActors: sms_template_actors,
    consoleTemplateActors: console_template_actors,
    pushTemplateActors: push_template_actors,
    emailTemplateRoles: email_template_roles,
    smsTemplateRoles: sms_template_roles,
    consoleTemplateRoles: console_template_roles,
    pushTemplateRoles: push_template_roles,
    ruleGroups: rule_groups_pks,
    ...rest
  };
};
class TransitionEntity {
  constructor({
    mapValues,
    ...data
  }) {
    _defineProperty(this, "mapToSnakeCase", () => {
      return {
        transition_master: this.transitionMaster?.pk ? {
          pk: this.transitionMaster.pk
        } : undefined,
        allowed_by_pks: this.allowedByPks,
        notify_pks: this.notifyPks,
        attribute_only_transition: this.attributeOnlyTransition,
        entity_attribute: this.entityAttribute || '',
        attribute_condition: this.attributeCondition || '',
        notify_to_email: this.notifyToEmail,
        is_active: this.isActive,
        organisation: this.organisation,
        email_template_actors: this.emailTemplateActors?.pk ? {
          pk: this.emailTemplateActors.pk
        } : {},
        sms_template_actors: this.smsTemplateActors?.pk ? {
          pk: this.smsTemplateActors.pk
        } : {},
        push_template_actors: this.pushTemplateActors?.pk ? {
          pk: this.pushTemplateActors.pk
        } : {},
        console_template_actors: this.consoleTemplateActors?.pk ? {
          pk: this.consoleTemplateActors.pk
        } : {},
        email_template_roles: this.emailTemplateRoles?.pk ? {
          pk: this.emailTemplateRoles.pk
        } : {},
        push_template_roles: this.pushTemplateRoles?.pk ? {
          pk: this.pushTemplateRoles.pk
        } : {},
        sms_template_roles: this.smsTemplateRoles?.pk ? {
          pk: this.smsTemplateRoles.pk
        } : {},
        console_template_roles: this.consoleTemplateRoles?.pk ? {
          pk: this.consoleTemplateRoles.pk
        } : {},
        rule_groups_pks: this.ruleGroups
      };
    });
    if (mapValues) data = mapToCamelCase(data);
    this.fromStatus = data?.transitionMaster?.from_status;
    this.toStatus = data?.transitionMaster?.to_status;
    this.transitionMaster = data?.transitionMaster;
    this.allowedByPks = data.allowedByPks;
    this.notifyPks = data.notifyPks;
    this.attributeOnlyTransition = data.attributeOnlyTransition;
    this.entityAttribute = data.entityAttribute;
    this.attributeCondition = data.attributeCondition;
    this.notifyToEmail = data.notifyToEmail;
    this.organisation = data.organisation;
    this.pk = data.pk;
    this.createdAt = data.createdAt;
    this.isActive = data.isActive;
    this.emailTemplateActors = data.emailTemplateActors;
    this.smsTemplateActors = data.smsTemplateActors;
    this.consoleTemplateActors = data.consoleTemplateActors;
    this.pushTemplateActors = data.pushTemplateActors;
    this.emailTemplateRoles = data.emailTemplateRoles;
    this.smsTemplateRoles = data.smsTemplateRoles;
    this.consoleTemplateRoles = data.consoleTemplateRoles;
    this.pushTemplateRoles = data.pushTemplateRoles;
    this.ruleGroups = data.ruleGroups;
  }
}
export { TransitionMasterEntity, TransitionEntity };